import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ModalDialogResult } from '../../../models/modal-dialog-result';
import { CommonModule } from '@angular/common';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyDateSelectionComponent } from '../../formly/formly-date-selection/formly-date-selection.component';
import { ApproveCondition } from '../../../models/approve-condition.model';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-reject',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    ReactiveFormsModule,
  ],
  templateUrl: './approve-conditionally-modal.html',
  styleUrl: './approve-conditionally-modal.scss'
})
export class ApproveConditionallyModalComponent {
  @Input() title: string = 'Approve for review?';
  @Input() message: string = 'Please confirm that you want to approve the application, but mark it for review later?';

  public onClose: Subject<ModalDialogResult<ApproveCondition>> = new Subject();

  protected model: ApproveCondition = {
    reason: null,
    reviewOn: DateTime.now().plus({ days: 14 }).toFormat('yyyy-MM-dd')
  };

  protected form = new FormGroup({});
  protected fields: FormlyFieldConfig[] = [
    {
      key: 'reason',
      type: 'textarea',
      props: {
        label: 'Reason',
        placeholder: 'Please explain why you approve the application conditionally, so the visitor knows what to do',
        required: true,
        rows: 5
      },
    },
    {
      key: 'reviewOn',
      type: FormlyDateSelectionComponent,
      props: {
        label: 'Review deadline',
        labelPosition: 'floating',
        placeholder: 'reviewOn',
        required: true
      },
      validators: {
        validation: ['date', 'todayOrLater'],
      }
    }
  ];

  constructor(public activeModal: NgbActiveModal) {
  }

  ok() {
    this.onClose.next({ result: true, entity: this.model });
    this.activeModal.dismiss();
  }

  cancel() {
    this.onClose.next({ result: false, entity: null });
    this.activeModal.dismiss();
  }
}
